<script>
  import LoanOption from "./LoanOption.svelte";
  import { fly, fade } from "svelte-transitions";
  import { createEventDispatcher } from "svelte";
  import { auth, db } from "../firebase";

  export let loanAmount;
  export let creditScore;
  export let borrowerCount;
  export let state;
  export let closingDate;
  const dispatch = createEventDispatcher();

  let user = JSON.parse(localStorage.getItem("user"));

  let submittedLoan;
  let loanOptions = [
    {
      loanAmount: loanAmount,
      title: "5 Year Fixed",
      interestRate: getInterestRate(5),
      numberOfYears: 5,
      creditScore: creditScore,
      state: state,
      borrowerCount: borrowerCount,
      closingDate: closingDate
    },
    {
      title: "4 Year Fixed",
      loanAmount: loanAmount,
      interestRate: getInterestRate(4),
      numberOfYears: 4,
      creditScore: creditScore,
      state: state,
      borrowerCount: borrowerCount,
      closingDate: closingDate
    },
    {
      title: "3 Year Fixed",
      loanAmount: loanAmount,
      interestRate: getInterestRate(3),
      numberOfYears: 3,
      state: state,
      creditScore: creditScore,
      borrowerCount: borrowerCount,
      closingDate: closingDate
    }
  ];

  let loanOptionSubmitted = false;
  function getInterestRate(numberOfYears) {
    let rate = 9.0;

    if (numberOfYears === 4) {
      rate += 2.0;
    } else if (numberOfYears === 5) {
      rate += 4.0;
    }

    if (creditScore < 720) {
      rate += 3.0;
    }

    if (creditScore < 700) {
      rate += 3.0;
    }

    if (creditScore < 680) {
      rate += 3.0;
    }

    if (creditScore < 660) {
      rate += 3.0;
    }

    if(creditScore < 640) {
      rate += 3.0;
    }

    return rate;
  }

  function startOver() {
    dispatch("startOver");
  }

  function optionSubmitted(data) {
    loanOptionSubmitted = true;
    submittedLoan = data.detail;
  }

  function getBorrowerNames() {
    if (!submittedLoan) {
      return "your borrower";
    }
    let name = submittedLoan.borrowerName;

    if (submittedLoan.coborrowerName) {
      name = `${name} and ${submittedLoan.coborrowerName}`;
    }
    return name;
  }
</script>

<style>
  .row {
    text-align: center;
    padding: 1em;
  }

  .loan-details {
    padding: 1em;
  }
</style>

{#if !loanOptionSubmitted}
  <div class="row">
    <div class="loan-details col">
      <span>State:</span>
      {state}
    </div>
    <div class="loan-details col">
      <span>Loan Amount:</span>
      ${loanAmount + 100}.00
      <p>($100 origination fee)</p>
    </div>
    <div class="loan-details col">
      <span>Credit Score:</span>
      {creditScore}
    </div>
    <div class="loan-details col">
      <span># of Borrowers:</span>
      {borrowerCount}
    </div>
  </div>
{/if}

<div class="container">
  {#if loanOptionSubmitted}
    <h2>We got it!</h2>
    {#if user && user.profession === 'lo'}
      <p>
        Thank you for connecting us with {getBorrowerNames()}! We strive to help
        you get your borrower into a home. We can do same day funding when they
        apply so this can all happen very quickly.
      </p>
      <p>
        Here are the documents we are going to request from your borrower so you
        can email them to them and streamline the process.
      </p>
      <ol>
        <li>
          <strong>Driver License or Government ID</strong>
        </li>
        <li>
          <strong>
            Copy of credit report (we will use yours and not pull another)
          </strong>
        </li>
        <li>
          <strong>Copy of mortgage commitment</strong>
        </li>
      </ol>
    {:else if user && user.profession === 'buyer'}
      <p>
        You have completed the first step in receiving a loan to finance your
        closing cost! If you fill out the brief application link below we can
        get the funds set up to be sent today!
      </p>
      <p>
        <strong>
          Up next is to
          <a
            target="_blank"
            href="https://leadbankonline.onlineportalnow.com">
            Apply now
          </a>
          through our bank partner.
        </strong>
      </p>
      <p>
        After finishing the short application it will ask you to upload 3
        documents.
      </p>
      <ol>
        <li>
          <strong>
            A copy of your driver’s license or a government issued ID.
          </strong>
        </li>
        <li>
          <strong>A copy of your credit report</strong>
          so we don’t have to pull your credit again. Ask your mortgage loan
          officer for this.
        </li>
        <li>
          <strong>Underwriting decision/Conditional approval</strong>
          , this will also come from your mortgage loan officer and confirms
          your mortgage has gone through underwriting.
        </li>
      </ol>
      <p>
        Once these are uploaded we will send our loan docs for e-signing and we
        can fund!
      </p>
    {:else}
      <p>
        We have successfully received your loan request and will be reaching out
        to you within the next 24 hours.
      </p>
    {/if}
    <p>
      If you have questions reach out to us at <a href="mailto:admin@closingcosthelp.com">admin@closingcosthelp.com</a>
    </p>
  {:else}
    <div class="mb-3 text-center row">
      {#each loanOptions as option, i}
        <div
          class="col-md-4"
          in:fly={{ y: 300, delay: 400 * i, duration: 1000 }}>
          <LoanOption {...option} on:optionSubmitted={optionSubmitted} />
        </div>
      {/each}
    </div>
  {/if}

  <div class="mb-3 row">
    <button
      in:fade={{ delay: 500 * loanOptions.length, duration: 1500 }}
      type="button"
      class="btn btn-lg btn-block btn-outline-secondary"
      style="max-width:250px; margin:auto;"
      on:click={startOver}>
      Start Over
    </button>
  </div>
</div>
